module.controller('mobileIdWelcomeCtrl', ['$scope', '$state', '$stateParams', function ($scope, $state, $stateParams) {
  $scope.successMessage = $stateParams.successMessage;
}]);
